import { render } from "./CategoryBlog.vue?vue&type=template&id=05875c62"
import script from "./CategoryBlog.vue?vue&type=script&lang=js"
export * from "./CategoryBlog.vue?vue&type=script&lang=js"

import "./CategoryBlog.vue?vue&type=style&index=0&id=05875c62&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__